import {openRouteInNewTab} from '~/shared/router';

export const onTermsOfUseClick = () => openRouteInNewTab('/terms-of-use');
export const onPrivacyPolicyClick = () => openRouteInNewTab('/privacy-policy');
export const onDealsPolicyClick = () => openRouteInNewTab('/deals-policy');
